export default {
  alignment: 'Wyrównanie',
};
